import React from "react";
import Spinner from "components/Spinner/Spinner";

const TileBody = ({ children, className, grey }) => {
    return (
        <div className={`Tile-body ${className ? className : ""} ${grey ? "u-bg-grey" : ""}`}>
            <div className="Tile-loader">
                <Spinner />
                <p className="lead u-textWhite">Loading...</p>
            </div>
            {children}
        </div>
    );
};
export default TileBody;
